import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async update ({ state, commit, dispatch }) {
    try {
      await directus.updateItem('site_config', 1, {
        name: state.name,
        tel: state.tel,
        email: state.email
      })

      commit('nav/setAttr', {
        name: 'siteName',
        value: state.name
      }, { root: true })

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
